import React, { useCallback, Fragment } from 'react'
import PropTypes from 'prop-types'
import compose from 'recompose/compose'
import injectJss from 'react-jss'
import classNames from 'classnames'
import CloseButton from 'public/assets/svg/close-button-black.svg'

import IframeCommunication from 'aria-viewer/common/components/IframeCommunication'

import { styles } from './styles'

/**
 * Modal to display iframe contents
 */
const IframeModal = (
    {
        classes,
        src,
        onIframeLoad,
        onDismiss,
        onComplete,
        onReady,
        onReceiveMessage: receiveMessage,
        onPersonalizationComplete,
        completeMessage,
        readyMessage,
        hasBorder,
        iframeRef,
        closeButtonRef,
    },
    ref
) => {
    return (
        <IframeCommunication
            // eslint-disable-next-line
            children={({ sendMessage }) => (
                <Fragment>
                    <div id={'iframe-modal-backdrop-container'} className={classes.iframeBackdropContainer} />
                    <div
                        id={'iframe-modal-container'}
                        className={classNames([
                            classes.iframeContainer,
                            {
                                [classes.iframeContainerBorder]: hasBorder,
                            },
                        ])}
                    >
                        <iframe
                            id={'iframe-modal-iframe'}
                            className={classes.registrationIframe}
                            src={src}
                            onLoad={onIframeLoad}
                            ref={iframeRef}
                        />
                        <div
                            className={classes.closeButton}
                            role="button"
                            aria-label="close conversational inquiry form"
                            tabIndex={100}
                            onClick={useCallback(_ => {
                                onDismiss && onDismiss(false)
                            })}
                            onKeyPress={useCallback(e => {
                                if (e.which == 13) onDismiss && onDismiss(false)
                            })}
                            ref={closeButtonRef}
                        >
                            <img aria-hidden="true" src={CloseButton} />
                        </div>
                    </div>
                </Fragment>
            )}
            onReceiveMessage={({ data }) => {
                if (completeMessage == data.message) {
                    onComplete && onComplete(data.millisecondsUntilClose || 4000)
                }
                if (data.message == ':::personalization') {
                    onPersonalizationComplete && onPersonalizationComplete()
                }
                if (readyMessage == data) {
                    onReady && onReady()
                }
                receiveMessage && receiveMessage(data)
            }}
            targetOrigin="*"
        />
    )
}

IframeModal.defaultProps = {
    src: null,
    onIframeLoad: () => {},
    //Called when close button is clicked
    onDismiss: () => {},
    //called when complete message is fired
    onComplete: () => {},
    //called when ready message is fired
    onReady: () => {},
    //recieved message from iframe
    onReceiveMessage: data => {},
    //the iframe complete message
    completeMessage: 'Iframe_Completed',
    //the iframe complete message
    readyMessage: 'Iframe_Ready',
    //render close button
    showCloseButton: true,
}

IframeModal.propTypes = {
    src: PropTypes.string,
}

export default injectJss(styles)(IframeModal)
